import {
	customBrands,
	customBrandChoices,
} from '@/_new-code/products/flexible-web-toolkit/blocks/helpers'
import {brandColors} from '@/_new-code/products/flexible-web-toolkit/colors/brand-colors'

/**
 * Gets brand color classes for Tailwind CSS styling
 * @param brandColor - The brand color codename
 * @param fallback - Fallback color if brandColor is not found
 * @returns Object with text, bg, border, and hover classes
 */
export function getBrandColorClasses(
	brandColor?: string | null,
	fallback = 'elanco-blue'
): {
	text: string
	bg: string
	border: string
	hover: string
} {
	const colorName = brandColor || fallback

	if (customBrandChoices.includes(colorName)) {
		const customBrand = customBrands[colorName]
		return {
			text: `text-${colorName}`,
			bg: customBrand?.background || `bg-${colorName}`,
			border: customBrand?.border || `border-${colorName}`,
			hover: `hover:bg-${colorName}/10`,
		}
	}

	if (Object.prototype.hasOwnProperty.call(brandColors, colorName)) {
		return {
			text: `text-${colorName}`,
			bg: `bg-${colorName}`,
			border: `border-${colorName}`,
			hover: `hover:bg-${colorName}/10`,
		}
	}

	return {
		text: 'text-blue-600',
		bg: 'bg-blue-600',
		border: 'border-blue-600',
		hover: 'hover:bg-blue-50',
	}
}
